module.exports = {"title":"Contact me","layout":"page","path":"/contact","body":"<p>Feel free to send me an email.\nI’m usually quite responsive as long as I have the connection.</p>\n<p><strong>Email:</strong> <strong><a href=\"mailto:erdalmutlu.su@gmail.com\">erdalmutlu.su@gmail.com</a></strong><br>\n<strong>GitHub:</strong> <strong><a href=\"http://www.github.com/erdalmutlu\">www.github.com/erdalmutlu</a></strong><br>\n<strong>Twitter:</strong> <strong><a href=\"http://www.twitter.com/erdalmutlu\">www.twitter.com/erdalmutlu</a></strong></p>\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/contact/index.md
// module id = 497
// module chunks = 0